import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function Devicemapping() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchDate, setSearchDate] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  // 🔹 Delete Mapping
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody({ id: selectedId }, secretKey);

      const response = await axios.post("/api/devicepatientmapping/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        toast.success(decryptedResponse.message || "Patient Device Mapping deleted successfully!");
        setDeleteModal(false);
        fetchMapping();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete mapping.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch All Mappings
  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/devicepatientmapping/all`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };
 
// 🔹 Reset page when search term changes
useEffect(() => {
  setCurrentPage(1); // always start from page 1 on new search
}, [searchTerm]);

// 🔹 Fetch mapping or search when currentPage or searchTerm changes
useEffect(() => {
  if (searchTerm?.trim()) {
    // Search by patient/device name
    searchData(currentPage);
  } else if (searchDate) {
    // Search by date
    searchByDate(currentPage);
  } else {
    // Fetch all mappings if no search/filter
    fetchMapping(currentPage);
  }
}, [searchTerm, searchDate, currentPage]);

  
 
const searchData = async (pageNumber = 1) => {
  setLoading(true);
  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    // Encrypt only the body fields expected by your API
    const requestBody = encryptBody(
      {
       
        searchTerm: searchTerm.trim(),
      },
      secretKey
    );

    const response = await axios.post(
      "/api/devicepatientmapping/searchByPatientOrDevice",
      requestBody,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const decryptedData = decryptBody(response.data, secretKey);
      console.log("Decrypted Search Response:", decryptedData);

      setMappingList(decryptedData.content || []);
      setCurrentPage(decryptedData.number + 1 || 1);
      setTotalPages(decryptedData.totalPages || 1);
    }
  } catch (error) {
    console.error("Error searching:", error);
    toast.error("Failed to fetch search results.");
  } finally {
    setLoading(false);
  }
};


 
const searchByDate = async (pageNumber = 1) => {
  setLoading(true);
  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;

    // Encrypt only the body fields expected by your API
    const requestBody = encryptBody(
      {
        ccid: userid,
        searchTerm: searchDate.trim(),
      },
      secretKey
    );

    const response = await axios.post(
      "/api/devicepatientmapping/searchByDate",
      requestBody,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      const decryptedData = decryptBody(response.data, secretKey);
      console.log("Decrypted Search Response:", decryptedData);

      setMappingList(decryptedData.content || []);
      setCurrentPage(decryptedData.number + 1 || 1);
      setTotalPages(decryptedData.totalPages || 1);
    }
  } catch (error) {
    console.error("Error searching:", error);
    toast.error("Failed to fetch search results.");
  } finally {
    setLoading(false);
  }
};

const handlePageChange = (_, pageNumber) => {
  setCurrentPage(pageNumber);
};

  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
 <MDBox mt={1} p={1} display="flex"  alignItems="center">
      <MDTypography variant="h5" sx={{ flex: 1 }}>
       Device Mapping
  </MDTypography>
  <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <MDInput
            placeholder="Search  Name "
            variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          maxWidth: "400px",
          backgroundColor: "#fff",
          borderRadius: "8px",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton size="small">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
        </MDBox>
    
    <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
  <MDInput
    label="Search Date"
    type="date"  // 👈 makes it a date picker
    variant="outlined"
    fullWidth
    value={searchDate}
    onChange={(e) => setSearchDate(e.target.value)}
    sx={{ maxWidth: "400px" }}
    InputLabelProps={{
      shrink: true, // 👈 ensures label doesn't overlap with date value
    }}
  />
</MDBox>

        <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>


          <MDButton
            variant="gradient"
            onClick={() => navigate("/CreateDevicemapping")}
            sx={{
              background: "#1A237E",
              color: "#fff",
              "&:hover": {
                background: "#1A237E",
              },
            }}
          >
            Create Mapping
          </MDButton>
       
    </MDBox>
   

      </MDBox>
     

      {/* Table */}
<MDBox sx={{ overflowX: "auto", width: "100%" }}>
  <TableContainer
    component={Paper}
    sx={{
      mt: 3,
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "2px 4px 10px rgba(0,0,0,0.1)",
    }}
  >
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
      {/* Table Head */}
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1A237E" }}>
          {["Patient Name", "Device Name", "Assign Date", "Care Coordinator Name","Actions"].map((header, index) => (
            <TableCell
              key={index}
              sx={{
                   color: "#fff",
                fontWeight: "600",  
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
                minWidth: index === 0 ? "310px" : "280px",
                width: index === 0 ? "335px" : "225px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      

      {/* Table Body */}
      <TableBody>
        {mappingList.length > 0 ? (
          mappingList.map((mapping, index) =>(
            
            <TableRow key={index}>
              {/* Patient Name */}
              <TableCell
                sx={{
                  border: "1px solid #ddd",
                  textAlign: "center",
                  padding: "12px",
                  // cursor:
                  //   mapping?.patient?.id || mapping?.patientid || mapping?.patientId
                  //   ? "pointer"
                  //   : "default",
                  // textDecoration:
                  // mapping?.patient?.id || mapping?.patientid || mapping?.patientId
                  // ? "underline"
                  // : "none",
                  // color:
                  // mapping?.patient?.id || mapping?.patientid || mapping?.patientId
                  // ? "blue"
                  // : "gray",
                }}
                // onClick={() => {
                //   const patientId = mapping?.patient?.id || mapping?.patientid;
                //   if (patientId) {
                //     navigate(`/PatientViewDetails/${patientId}`);
                //   }
                //  }}
              >
                {mapping?.patient?.firstname || mapping?.patientFirstName || "-"} {mapping?.patient?.lastname || mapping?.patientLastName || ""}
              </TableCell>

              {/* Device Name */}
              <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                {mapping?.device?.devicename || mapping?.deviceName || "-"}
              </TableCell>

              {/* Assign Date */}
              <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                {mapping?.assignedDate || "-"}
              </TableCell>
 <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                {mapping?.ccName || "-"}
              </TableCell>
              {/* Actions */}
              <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                <IconButton color="default" onClick={() => handleOpenDeleteModal(mapping.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={4}
              align="center"
              sx={{
                border: "1px solid #ddd",
                padding: "12px",
                fontStyle: "italic",
                color: "gray",
              }}
            >
              No Data Available.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      </TableHead>
    </Table>

    {/* Pagination */}
    <Box mt={2} display="flex" justifyContent="center">
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handlePageChange}
        color="success"
        sx={{
          "& .MuiPaginationItem-root": {
            borderRadius: "4px",
            color:  "#1A237E",
            borderColor:  "#1A237E",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor:  "#1A237E",
            color: "#fff",
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor:  "#1A237E",
          },
        }}
      />
    </Box>
  </TableContainer>
</MDBox>


      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this mapping?
          </MDTypography>
          <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background:  "#1A237E", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default Devicemapping;
